/**
 * Limited Quantity Sale - Countdown Timer
 * Handles countdown functionality for both card and bar layouts
 */

class LimitedQuantityCountdown {
  constructor(element) {
    this.element = element;
    this.endDate = new Date(element.dataset.endDate);
    this.daysEl = element.querySelector('.lq-countdown-days, .lqb-countdown-days');
    this.hoursEl = element.querySelector('.lq-countdown-hours, .lqb-countdown-hours');
    this.minutesEl = element.querySelector('.lq-countdown-minutes, .lqb-countdown-minutes');
    this.secondsEl = element.querySelector('.lq-countdown-seconds, .lqb-countdown-seconds');

    // Check if end date is valid
    if (isNaN(this.endDate.getTime())) {
      console.error('Invalid end date:', element.dataset.endDate);
      return;
    }

    // Start the countdown
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date();
    const timeRemaining = this.endDate - now;

    // Check if countdown has expired
    if (timeRemaining <= 0) {
      this.handleExpired();
      return;
    }

    // Calculate time units
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Update display
    this.daysEl.textContent = String(days).padStart(2, '0');
    this.hoursEl.textContent = String(hours).padStart(2, '0');
    this.minutesEl.textContent = String(minutes).padStart(2, '0');
    this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  handleExpired() {
    // Stop the interval
    clearInterval(this.interval);

    // Update display to show zeros
    this.daysEl.textContent = '00';
    this.hoursEl.textContent = '00';
    this.minutesEl.textContent = '00';
    this.secondsEl.textContent = '00';

    // Add expired class
    this.element.classList.add('lq-countdown--expired', 'lqb-countdown--expired');

    // Optionally hide the entire sale component or show "Sale Ended" message
    const saleBox = this.element.closest('.limited-quantity-box, .limited-quantity-bar');
    if (saleBox) {
      // You can choose to hide it or add an "expired" state
      // saleBox.style.display = 'none'; // Uncomment to hide
      saleBox.classList.add('limited-quantity--expired');
    }
  }

  destroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
}

// Initialize all countdown timers on page load
function initCountdownTimers() {
  const countdownElements = document.querySelectorAll('[data-end-date]');
  const timers = [];

  countdownElements.forEach(element => {
    const timer = new LimitedQuantityCountdown(element);
    timers.push(timer);
  });

  return timers;
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdownTimers);
} else {
  initCountdownTimers();
}

// Re-initialize when Shopify sections are updated (theme editor)
document.addEventListener('shopify:section:load', initCountdownTimers);
